/**
 * @module Description
 */

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { RequirementsType } from '@models/requirement.model';
import { LanguagesTypes } from '@functions/language.functions';
import { LanguageType } from '@models/language.model';
import { DescriptionsModel } from '@models/descriptions.model';
import { ModificationClass, ModificationStateClass } from '@class/modification.class';
import { DeepCopy } from '@functions/copy.functions';
import { SetDescriptions } from '@functions/descriptions.functions';

export class DescriptionsClass extends ModificationClass<DescriptionsModel> {

  protected _parent: DescriptionsModel;
  protected _inital: DescriptionsModel;
  protected _attributes: string[];

  constructor(descriptions: DescriptionsModel, form: FormGroup, requirements: RequirementsType, state: ModificationStateClass, minLength: number = 0, maxLength: number = 500) {
    
    super();

    this._parent = descriptions;
    this._requirements = requirements;
    this._attributes = this.attributes;
    this._form = form;
    this._state = state;

    if(this._parent.descriptions === undefined) {  
      this._parent.descriptions = SetDescriptions();
    }

    Object.assign(requirements, {
      descriptions: {
        maxLength: maxLength,
        minLength: minLength
      }
    });

    LanguagesTypes().forEach((language: LanguageType) => {
      form.addControl(`${this.class}@${language}`, new FormControl(this._parent.descriptions[language], [ 
        Validators.maxLength(requirements[this.class].maxLength), 
        Validators.minLength(requirements[this.class].minLength) 
      ]));
    });

    //validation: si au moins 1 des descriptions est valide on valide les autres dans le formulaire
    let values = {} as DescriptionsModel;
    const isValid = Object.keys(this._parent.descriptions).filter((language: LanguageType) => {
      values[language] = this._parent.descriptions[language];
      return this._parent.descriptions[language].length > 0;
    }).length > 0;

    if(isValid) {
      this.change({ descriptions: values } as unknown as DescriptionsModel, false);
    }
    //.validation

    this._inital = DeepCopy({ descriptions: this._parent.descriptions });

  }

  get attributes(): string[] {
    return ['descriptions'];
  }

  get class(): string {
    return 'descriptions';
  }

  value(language: LanguageType): Readonly<string> {
    let lg = language;
    if(this._parent.descriptions[language] === undefined || this._parent.descriptions[language].length === 0) {
      for(const l in this._parent.descriptions) {
        if(this._parent.descriptions[l] !== undefined && this._parent.descriptions[l].length > 0) {
          lg = l as LanguageType; 
          break;
        }
      }
    }
    return /*(lg !== language ? `[${lg.toUpperCase()}] ` : '') +*/ this._parent.descriptions[lg]; // suppression du prefix de la langue par défaut
  }

}